"use strict";

var _slicedToArray = require("/home/runner/work/moderneyegallery/moderneyegallery/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var sortPrices = function sortPrices(a, b) {
  var aScheme = a.scheme;
  var bScheme = b.scheme;
  var aAmount = a.amount;
  var bAmount = b.amount;

  if (aAmount && bAmount && 'per_unit' === aScheme && 'per_unit' === bScheme) {
    return aAmount - bAmount;
  }

  if (['graduated', 'volume'].includes(aScheme) && ['graduated', 'volume'].includes(bScheme)) {
    if (a.tiers && b.tiers) {
      var _a$tiers$sort = a.tiers.sort(function (at, bt) {
        return bt.amount - at.amount;
      }),
          _a$tiers$sort2 = _slicedToArray(_a$tiers$sort, 1),
          aTier = _a$tiers$sort2[0];

      var _b$tiers$sort = b.tiers.sort(function (at, bt) {
        return bt.amount - at.amount;
      }),
          _b$tiers$sort2 = _slicedToArray(_b$tiers$sort, 1),
          bTier = _b$tiers$sort2[0];

      return aTier.amount - bTier.amount;
    }

    return 1;
  }

  if ('per_unit' === bScheme && bAmount) {
    return 1;
  }

  return -1;
};

exports.default = sortPrices;